var tenderEdit = angular.module('tenderEdit', [
    'uuid4',
    'angular-md5',
    'iso8601'
]);
